import { isPreviewEnv } from '@core/base/utils/environment';

const QUERY_KEY = 'remotejs';
const STORAGE_KEY = 'remotejs_channel';
const AGENT_URL = 'https://remotejs.com/agent/agent.js';

function resolveChannel(): string | null {
  const fromQuery = new URLSearchParams(globalThis.location.search).get(QUERY_KEY);

  try {
    if (fromQuery === 'off') {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }

    if (fromQuery) {
      sessionStorage.setItem(STORAGE_KEY, fromQuery);
      return fromQuery;
    }

    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return fromQuery === 'off' ? null : fromQuery;
  }
}

export default defineNuxtPlugin(() => {
  const { ENVIRONMENT } = useRuntimeConfig().public;

  if (!isPreviewEnv(ENVIRONMENT as string)) return;

  const channel = resolveChannel();

  if (!channel) return;

  const script = document.createElement('script');
  script.src = AGENT_URL;
  script.dataset.consolejsChannel = channel;
  document.head.appendChild(script);
});
